export const DataSetCustomLabel = {
  Dmf: 'SSA Death Master'
};
